import React from 'react';
import Typography from '@material-ui/core/Typography';
import { EntityRoutes } from 'routes/constants';

import { PlainLink } from '../../shared';

export const CandidateDetail = ({ item }) => {
  return (
    <div>
      <Typography variant="subtitle1" component="span">
        {item.full_name}
      </Typography>
      &nbsp;
      <Typography variant="body2" component="span">
        / {item.email}
      </Typography>
      <Typography variant="body1">
        {item.specialty} / {item.subspecialty}
      </Typography>
      <Typography variant="body1">{item.current_company}</Typography>
      <Typography variant="body2">{item.location}</Typography>
      <PlainLink
        itemId={item.id}
        linkProps={{
          type: 'local',
          url: EntityRoutes.CandidateProfile,
          target: '_blank'
        }}
        noWrap
        aria-label="Candidate Profile"
      >
        View Candidate
      </PlainLink>
    </div>
  );
};
